import { useEffect, useState } from "react";
import { getOnce } from "@/lib/api";

// Section names + one-line meanings, fetched once and shared by every icon/key.
let cache = null;
let pending = null;
const load = () => (pending ||= getOnce("/menus").then((d) => (cache = Object.fromEntries(d.menus.map((m) => [m.id, { name: m.short_name || m.name, intro: m.intro }])))));

export const useMenuMeta = () => {
  const [meta, setMeta] = useState(cache || {});
  useEffect(() => { load().then(setMeta).catch(() => {}); }, []);
  return meta;
};
